import definedAbility from "@/ability";

export const gtmWrapper = {
  push: gtmData => {
    if (definedAbility().cannot("use", "google tag manager")) return;

    window.dataLayer && window.dataLayer.push(gtmData);
  },
};

export const gtmPlugin = {
  install: Vue => {
    Vue.prototype.gtm = gtmWrapper;
  },
};
